import { useTranslation } from "@fmc-digital/i18n";
import { Text } from "@fmc-digital/ui";
import type { MFATimerProps } from "./mfa-timer.types";

/**
 * MFATimer Molecule
 * Displays code expiration countdown timer
 */
export function MFATimer({ minutes, seconds }: Readonly<MFATimerProps>) {
  const { t } = useTranslation();
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return (
    <Text variant="bodySmall" className="mfa-timer-text">
      {t("auth.mfa.codeExpiresIn", {
        minutes: formattedMinutes,
        seconds: formattedSeconds,
      })}
    </Text>
  );
}
